const styles = {
  loading: "border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/70 text-slate-600 dark:text-slate-400",
  error: "border-rose-200 dark:border-rose-800/50 bg-rose-50/90 dark:bg-rose-950/40 text-rose-900 dark:text-rose-300",
  empty: "border-dashed border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900/60 text-slate-600 dark:text-slate-400",
  success: "border-emerald-200 dark:border-emerald-800/50 bg-emerald-50/80 dark:bg-emerald-950/40 text-emerald-900 dark:text-emerald-300",
};

const labels = {
  loading: "A carregar…",
  error: "Não foi possível carregar os dados.",
  empty: "Não existem registos para mostrar.",
  success: "Operação concluída.",
};

export default function StatusMessage({ type = "empty", title, children, action, className = "" }) {
  return (
    <div className={`rounded-2xl border px-4 py-5 text-sm ${styles[type] || styles.empty} ${className}`} role={type === "error" ? "alert" : "status"}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-semibold">{title || labels[type] || labels.empty}</p>
          {children ? <div className="mt-1 text-sm opacity-90">{children}</div> : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </div>
  );
}
